module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title16"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Table of Contents")])]), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    attrs: {
      "id": "title16"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781439633878_tp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781439633878_cop01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781439633878_ack01"
    }
  }, [_c('span', [_vm._v("ACKNOWLEDGMENTS")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781439633878_fm02"
    }
  }, [_c('span', [_vm._v("INTRODUCTION")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633878_c01"
    }
  }, [_c('span', [_vm._v("1 - FRIDAY NIGHT LIGHTS AND SATURDAY’S HEROES")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633878_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("2 - “GET YOUR KICKS . . .”")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633878_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("3 - HOOPIN’ IT UP")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633878_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("4 - GRAPPLING WITH SUCCESS")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633878_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("5 - OUR NATIONAL PASTIME")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633878_c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("6 - RUNNING, JUMPING, AND THROWING")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633878_c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("7 - HOORAY FOR OUR SIDE!")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633878_c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("8 - THE GREAT OUTDOORS")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633878_c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("9 - OTHER GAMES ON OTHER FIELDS")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781439633878_c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("10 - THE NEXT LEVEL")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab10d46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439633878_toc01.vue
// module id = 66
// module chunks = 0